import React from 'react';
import '../css/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 MechArtista Technocrafts. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
